module.exports = __webpack_public_path__ + "img/szfw-gtfqw.6ba2fa94.png";